import React, { useCallback, useState } from 'react';

import { Tabs, Tab } from '../../shared/tabs.component';
import { withPermissions, permissions } from '../../shared/authorization';

import BalanceSheetManagementTab from './balanceSheetManagementTab/balanceSheetManagementTab.component';
import ConnectionsTab from './connectionsTab/connectionsTab.component';
import RollTab from './rollTab/rollTab.component';
import BookToTaxCodesTab from './bookToTaxCodeDescriptionTab/bookToTaxCodeDescriptionTab.component';
import CountriesTab from './countriesTab/countriesTab.component';
import CurrenciesTab from './currenciesTab/currenciesTab.component';
import MaintenanceModeAndLockTab from './maintenanceModeAndLockTab/maintenanceModeAndLockTab.component';

type TabItem = {
  key: string,
  label: string,
  component?: React.ReactNode,
  tabs?: TabItem[],
}

interface RenderTabsProps {
  tabs: TabItem[],
  defaultTab: string,
  subTab?: boolean
}

const RenderTabs = ({ tabs, defaultTab, subTab }: RenderTabsProps) => {
  const [currentTab, setCurrentTab] = useState<string>(defaultTab);

  const handleOnChangeTab = useCallback((_event: any, nextTab: string) => {
    const selectedTab = tabs.find(({ key }) => key === nextTab);
    if (selectedTab) {
      setCurrentTab(selectedTab.key);
    }
  }, [tabs]);

  return (
    <Tabs
      defaultValue={currentTab}
      value={currentTab}
      onChange={handleOnChangeTab}
      className={subTab ? 'a-tab-bar-margin-10-sub' : 'a-tab-bar-margin-10'}
      size="md"
    >
      {tabs.map(({ key, label, component, tabs: subTabs }, i) =>
        <Tab key={`${key}_${i}`} value={key} label={label} onChange={handleOnChangeTab}>
          {subTabs && <RenderTabs tabs={subTabs} defaultTab={subTabs[0].key} subTab />}
          {component}
        </Tab>
      )}
    </Tabs>
  );
};

interface ClientAdministrationPageProps {
  canModify: boolean,
  canView: boolean,
  canModifyInSelectedPeriod: boolean,
}

const ClientAdministrationPage = ({ canModify }: ClientAdministrationPageProps) => {
  const tabs: TabItem[] = [
    {
      key: 'connections',
      label: 'Connections',
      component: <ConnectionsTab canModify={canModify} />,
    },
    {
      key: 'balance',
      label: 'Balance Sheet Management',
      component: <BalanceSheetManagementTab />,
    },
    {
      key: 'roll',
      label: 'Roll',
      component: <RollTab />,
    },
    {
      key: 'book',
      label: 'Book to Tax Code Descriptions',
      component: <BookToTaxCodesTab canModify={canModify} />,
    },
    {
      key: 'countries',
      label: 'Countries and Currencies',
      tabs: [
        {
          key: 'currencies',
          label: 'Currencies',
          component: <CurrenciesTab canModify={canModify} />,
        },
        {
          key: 'countries',
          label: 'Countries',
          component: <CountriesTab canModify={canModify} />,
        },
      ],
    },
    {
      key: 'maintenance',
      label: 'Maintenance Mode and Lock',
      component: <MaintenanceModeAndLockTab />,
    },
  ];

  return (
    <div className="client-administration-page page">
      <div className="container-fluid">
        <div className="row no-gutters page-content-container">
          <div className="col">
            <div className="d-flex flex-row justify-content-between">
              <h5>Client Administration</h5>
            </div>
          </div>
        </div>
        <div className="row no-gutters page-content-container">
          <div className="col">
            <div className="view-journal-grids page-content-container">
              <RenderTabs tabs={tabs} defaultTab={tabs[0].key} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withPermissions(permissions.CLIENT_ADMININISTRATION)(ClientAdministrationPage);
